import React from 'react';
import SectionBanner from '../../components/Banner';
import CustomerCard from '../../components/customer_card';
import SignupRectangle from '../../components/signup_rectange';

// SVGs
import Logo1 from '../../assets/customer/Ellipse_1.svg';
import Logo2 from '../../assets/customer/Ellipse_2.svg';
import Logo3 from '../../assets/customer/Ellipse_3.svg';
import Logo4 from '../../assets/customer/Ellipse_4.svg';
import Logo5 from '../../assets/customer/Ellipse_5.svg';
import Logo9 from '../../assets/customer/Ellipse_9.svg';
import Logo10 from '../../assets/customer/Ellipse_10.svg';
import Logo13 from '../../assets/customer/Ellipse_13.svg';
import Logo16 from '../../assets/customer/Ellipse_16.svg';

// CSS
import './Customer.css';
import AppNavBar from '../../helper/appbar';

const Customer = () => {
    return (
        <div>
            <AppNavBar navType={'_light'} />
            <SectionBanner
                title={'Customers'}
                tagline={"Get an insider's perspective on how our customers achieve superior travel management results."}
            />
            <section className='customer_main_section'>
                <section className='customer_section_card_article'>
                    <CustomerCard
                        image={Logo4}
                        text={"Kardinal has made our lives easier by providing easy-to-use reports, mobile responsiveness, and quick response times."}
                        subText={"Thompson"}
                        subText1={"Fidson Healthcare PLC"}
                    ></CustomerCard>
                    <CustomerCard
                        image={Logo9}
                        text={"Travel for the entertainment industry can be quite daunting. However, with Kardinal’s platform, I easily derive all my invoices and send them to clients."}
                        subText={"Kema"}
                        subText1={"Kema Oyih Management"}
                    ></CustomerCard>
                    <CustomerCard
                        image={Logo10}
                        text={"No travel agency understands entertainment travel like Kardinal. From start to finish, I do not bother at all and that is a great thing."}
                        subText={"Eze"}
                        subText1={"Bean Creative"}
                    ></CustomerCard>
                </section>

                <section className='customer_section_card_article'>
                    <CustomerCard
                        image={Logo2}
                        text={"We really love the simplicity of Kardinal’s reporting and the product. Response time and customer support is also one of the best."}
                        subText={"Faith"}
                        subText1={"Parthian Partners"}
                    ></CustomerCard>
                    <CustomerCard
                        image={Logo5}
                        text={"Signing up on Kardinal gave us the flexiblilty on staff travel which is what we needed as a fast paced business."}
                        subText={"Chimdimma"}
                        subText1={"The Initiative for Equal rights"}
                    ></CustomerCard>
                    <CustomerCard
                        image={Logo13}
                        text={"Kardinal provides payment alternatives for us. This has made travel even more seamless for our company."}
                        subText={"Zaynab"}
                        subText1={"TASCK"}
                    ></CustomerCard>
                </section>

                <section className='customer_section_card_article'>
                    <CustomerCard
                        image={Logo1}
                        text={"Kardinal already does all the hard work required for me to book and manage all my travel activities."}
                        subText={"Anthonia"}
                        subText1={"JNCI"}
                    ></CustomerCard>
                    <CustomerCard
                        image={Logo3}
                        text={"We have had so much trouble reconciling travel expenses, but Kardinal gives us a simple solution to this problem."}
                        subText={"Desmond"}
                        subText1={"Chocolate City Music"}
                    ></CustomerCard>
                    <CustomerCard
                        image={Logo16}
                        text={"As a business owner, it can get very difficult searching for my preferred flight option from different websites until I came across Kardinal."}
                        subText={"Ebuka"}
                        subText1={"Maliko Studios"}
                    ></CustomerCard>
                </section>
            </section>

            <section className='customer_signup_rectangle'>
                <SignupRectangle />
            </section>
        </div>
    );
};

export default Customer;